"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wordCloudTitleOnlyLayout = exports.quizTitleOnlyLayout = exports.createLessonUpTemplate = void 0;
const helpers_1 = require("../helpers");
const tip_tap_1 = require("../tip-tap");
const template_style_set_1 = require("./template-style-set");
const slide_templates_1 = require("./slide-templates");
const open_question_templates_1 = require("./open-question-templates");
const createLessonUpTemplate = (translations = helpers_1.fallbackCopy) => {
    return {
        id: 'lesson-up',
        name: 'LessonUp',
        styleSets: template_style_set_1.LessonUpStyleSets,
        layouts: {
            slidePinLayouts: [
                (0, slide_templates_1.slideBlankLayout)({}),
                (0, slide_templates_1.slideCoverLayout)({}),
                (0, slide_templates_1.slideTitleWithBodytextLayout)({
                    title: {
                        content: (0, tip_tap_1.stringToProsemirror)(translations['slide.title'], {
                            bold: true,
                        }),
                    },
                    body: { content: (0, tip_tap_1.stringToProsemirror)(translations['slide.body']) },
                }),
                (0, slide_templates_1.slideImageLeftLayout)({
                    title: {
                        content: (0, tip_tap_1.stringToProsemirror)(translations['slide.title'], {
                            bold: true,
                        }),
                    },
                    body: { content: (0, tip_tap_1.stringToProsemirror)(translations['slide.body']) },
                }),
                (0, slide_templates_1.slideImageRightLayout)({
                    title: {
                        content: (0, tip_tap_1.stringToProsemirror)(translations['slide.title'], {
                            bold: true,
                        }),
                    },
                    body: { content: (0, tip_tap_1.stringToProsemirror)(translations['slide.body']) },
                }),
                (0, slide_templates_1.slideDoubleColumnImageLayout)({
                    textOne: {
                        content: (0, tip_tap_1.stringToProsemirror)(translations['image.caption']),
                    },
                    textTwo: {
                        content: (0, tip_tap_1.stringToProsemirror)(translations['image.caption']),
                    },
                }),
                (0, slide_templates_1.slideDoubleColumnTextLayout)({
                    title: {
                        content: (0, tip_tap_1.stringToProsemirror)(translations['slide.title'], {
                            bold: true,
                        }),
                    },
                    subTitleOne: {
                        content: (0, tip_tap_1.stringToProsemirror)(translations['column.title'], {
                            bold: true,
                        }),
                    },
                    textOne: {
                        content: (0, tip_tap_1.stringToProsemirror)(translations['column.body']),
                    },
                    subTitleTwo: {
                        content: (0, tip_tap_1.stringToProsemirror)(translations['column.title'], {
                            bold: true,
                        }),
                    },
                    textTwo: {
                        content: (0, tip_tap_1.stringToProsemirror)(translations['column.body']),
                    },
                }),
                (0, slide_templates_1.slideImageTopLayout)({
                    title: {
                        content: (0, tip_tap_1.stringToProsemirror)(translations['slide.title'], {
                            bold: true,
                        }),
                    },
                }),
                (0, slide_templates_1.slideFullSizeVideoLayout)({}),
            ],
            // TODO: recreate the 5 existing layouts
            quizPinLayouts: [
                quizTitleOnlyLayout({
                    question: translations['quiz.title'],
                }),
            ],
            openQuestionLayouts: [
                (0, open_question_templates_1.openQuestionTitleOnlyLayout)({
                    question: translations['openQuestion.title'],
                }),
                (0, open_question_templates_1.openQuestionFiftyFiftyLayout)({
                    question: translations['openQuestion.title'],
                }),
            ],
            wordCloudLayouts: [
                wordCloudTitleOnlyLayout({
                    question: translations['wordCloud.title'],
                }),
            ],
        },
    };
};
exports.createLessonUpTemplate = createLessonUpTemplate;
function quizTitleOnlyLayout({ question = helpers_1.fallbackCopy['quiz.title'], backgroundColor = '#D2D1FF', backgroundImage, }) {
    return {
        key: 'TITLE_ONLY',
        backgroundColor,
        backgroundImage,
        layoutParts: {
            TITLE: (0, helpers_1.newTextPinComponent)({
                position: (0, helpers_1.newVector)(32, 32),
                size: (0, helpers_1.newSize)(896, 60),
                content: (0, tip_tap_1.stringToProsemirror)(question, {
                    bold: true,
                }),
                order: 'a0',
                settings: {
                    fontFamily: 'Plus Jakarta Sans',
                    fontSize: '32px',
                    textStyleKey: 'TITLE',
                    horizontalAlignment: 'center',
                },
            }),
        },
        pinComponents: [],
    };
}
exports.quizTitleOnlyLayout = quizTitleOnlyLayout;
function wordCloudTitleOnlyLayout({ question = helpers_1.fallbackCopy['wordCloud.title'], backgroundColor = '#D2D1FF', bold = true, textPinComponentSettings = {}, pinComponentPosition = (0, helpers_1.newVector)(32, 240), pinComponentSize = (0, helpers_1.newSize)(896, 60), backgroundImage, }) {
    return {
        key: 'TITLE_ONLY',
        backgroundColor,
        backgroundImage,
        pinComponents: [],
        layoutParts: {
            TITLE: (0, helpers_1.newTextPinComponent)({
                position: pinComponentPosition,
                size: pinComponentSize,
                content: (0, tip_tap_1.stringToProsemirror)(question, {
                    bold,
                }),
                order: 'a0',
                settings: {
                    fontFamily: 'Plus Jakarta Sans',
                    fontSize: '32px',
                    textStyleKey: 'TITLE',
                    horizontalAlignment: 'center',
                    ...textPinComponentSettings,
                },
            }),
        },
    };
}
exports.wordCloudTitleOnlyLayout = wordCloudTitleOnlyLayout;
//# sourceMappingURL=lesson-up-template.js.map